import { useState, useCallback } from 'react';

import { useHttpClient } from './http-hook';

export const usePost = () => {
  const [posts, setPosts] = useState([]);
  const [totalPosts, setTotalPosts] = useState(0);
  const { sendRequest } = useHttpClient();

  const fetchAllPosts = useCallback(async () => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/posts/client`
      );

      setPosts(responseData.data.data);
      setTotalPosts(responseData.results);
    } catch (err) {}
  }, [sendRequest]);

  return { posts, totalPosts, fetchAllPosts };
};
